import addressFormatter from '@fragaria/address-formatter';

import type { Address } from '@/core/graphql/generated/types';

import { cleanAddressLines } from './cleanAddressLines';
import { getCountryCode } from './getCountryCode';

export const formatAddressTitle = (
	address: Address | null | undefined
): string => {
	if (!address) return '';

	const street1 = address.streetAddress1Cda_V?.trim();
	const street2 = address.streetAddress2Cda_V?.trim();
	const city = address.cityCda_V?.trim();

	if (!street1 && !street2 && !city) return '';

	const countryCode = getCountryCode(address.countryCda_V);
	const road = [street1, street2].filter(Boolean).join('\n');

	const rawLines = addressFormatter.format(
		{
			...(road && { road }),
			...(city && { city }),
			...(countryCode && { countryCode })
		},
		{
			output: 'array',
			abbreviate: false,
			appendCountry: false,
			cleanupPostcode: false
		}
	);

	return cleanAddressLines(rawLines).join(', ');
};
